export const TEXT_COLOR_LIGHT = '#8484A8';
export const APP_BACKGROUD_COLOR = '#FBFBFC';
